import { ScoreIndex } from '@internal/ui-common';
import { Team } from '@internal/schemas-common'

type resGetter<ResourceType, ScoreType> = {
  getTeam(s: ResourceType): string;
  getScore(res: ResourceType[]): ScoreType;
  sortScore(s1: ScoreType, s2: ScoreType): number;
};

export function getScore<ResourceType, ScoreType>(
  loading: boolean,
  teams: Team[],
  resources: ResourceType[] | undefined,
  resGet: resGetter<ResourceType, ScoreType>,
): ScoreIndex<ScoreType>[] | undefined {
  if (teams.length === 0) {
    return undefined;
  }

  if (!resources) {
    return undefined;
  }

  if (loading) return undefined;

  const mapping = new Map();
  teams.forEach((team, index) => {
    mapping.set(team.nameInGitlab, index);
  });

  const sortedResources: ResourceType[][] = Array(teams.length)
    .fill(0)
    .map(() => []);
  resources.forEach(resource => {
    const team = resGet.getTeam(resource);
    if (mapping.get(team) === undefined) {
      return;
    }
    sortedResources[mapping.get(team)].push(resource);
  });

  const ret_scores = sortedResources.map((sres, index) => ({
    index: index,
    score: resGet.getScore(sres),
  }));

  return ret_scores.sort((s1, s2) => resGet.sortScore(s1.score, s2.score));
}
